<template>
  <div>
    <v-card>
      <v-card-title class="secondary">
        <span class="subtitle white--text">Activity Log</span>
        <v-spacer></v-spacer>
        <v-icon class="white--text" @click="orgDialoge()">mdi-close</v-icon>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="activityLogTable"
        :items-per-page="5"
        class="elevation-1"
      >
        <template v-slot:item.log_command="{ item }">
          <span class="caption">{{ convertToUC(item.log_command) }}</span>
        </template>
        <template v-slot:item.log_device="{ item }">
          <span class="caption">{{ convertLogdevice(item.log_device) }}</span>
        </template>
        <template v-slot:item.serveyorname="{ item }">
          <span v-if="item.serveyorname!=''" class="caption">{{item.serveyorname }}</span>
          <span v-if="item.serveyorname==''" class="caption">-</span>
        </template>
        <template v-slot:item.log_on="{ item }">
          <span class="caption">{{ formatDate(item.log_on) }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["activityLogTable"],
  created() {},
  data() {
    return {
      headers: [
        { text: "Command", value: "log_command" },
        { text: "Date", value: "log_on" },
        { text: "Surveyor Name", value: "serveyorname" },
        {
          text: "Ref #",
          align: "start",
          sortable: false,
          value: "reference_number"
        },
        { text: "Activity", value: "log_description" },
        { text: "Platform", value: "log_device" }
      ]
    };
  },
  methods: {
    formatDate(date) {
      var date1 = date.split(" ")[0];
      console.log(date);
      if (!date1) return null;

      const [year, month, day] = date1.split("-");

      return `${month}/${day}/${year}`;
    },
    convertToUC(value) {
      return value.toUpperCase();
    },
    orgDialoge() {
      this.$emit("backEdit");
    },
    convertLogdevice(val) {
      if (val == 1) {
        return "Portal";
      } else if (val == 2) {
        return "Android";
      } else if (val == 3) {
        return "IOS";
      } else {
        return "-";
      }
    }
  }
};
</script>